exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outer_width{width:900px;}\n.red_shape.small_size{height: auto !important;}\n.mat-dialog-title{line-height: 25px;}\n.mat-input-container{width: 100% !important;}\n.mat-select{margin-top: 12px !important;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/distributor/profile/edit-attendee/edit-attendee.component.css
// module id = ../../../../../src/app/distributor/profile/edit-attendee/edit-attendee.component.css
// module chunks = 39